import { useQuery } from '@tanstack/react-query';
import { getLancamentos } from '../services/api';

interface LancamentosFilter {
    search: string;
    startDate: string;
    endDate: string;
    categoriaId?: number;
    faseId?: number;
    fornecedorId?: number;
    missingAttachments?: boolean;
    page?: number;
    pageSize?: number;
}

export const useLancamentos = (
    obraId: string | undefined,
    filters: LancamentosFilter,
    enabled: boolean = true,
    refreshTrigger: number = 0
) => {
    const {
        data,
        isLoading: loading,
        error,
        refetch
    } = useQuery({
        queryKey: ['lancamentos', obraId, filters, refreshTrigger], // Include refreshTrigger to force refetch
        queryFn: () => getLancamentos({
            obra_id: Number(obraId),
            categoria_id: filters.categoriaId,
            fase_obra_id: filters.faseId,
            fornecedor_id: filters.fornecedorId,
            search: filters.search,
            startDate: filters.startDate,
            endDate: filters.endDate,
            missingAttachments: filters.missingAttachments,
            page: filters.page,
            pageSize: filters.pageSize
        }),
        enabled: enabled && !!obraId,
    });

    return {
        lancamentos: data?.data || [],
        total: data?.total || 0,
        loading,
        error: error ? (error as Error).message : null,
        refetch,
        setLancamentos: () => { } // No-op
    };
};
